import { driver } from "driver.js";

export default driver({
  showProgress: true,
  smoothScroll: true,
  steps: [
    { popover: { title: 'Tutorial', description: 'Welcome to the RoRender Editor, this tutorial will help you get started' }},
  ]
})
